<dropdown
  [formControl]="currentOrganization"
  [placeholder]="'GLOBAL.SHOW_ORGANIZATION' | translate"
  [options]="organizations$ | async"
  class="organization-selector"
/>
